import { type Epic } from 'redux-observable';
import { filter, mergeMap } from 'rxjs';
import { type PayloadAction } from '@reduxjs/toolkit';
import { openSnackbar } from '@/core/features/snackbar';
import { navigate } from '@/slices/app';
import { type ErrorResponse } from '@/types';
import { translateError } from '@/utils';

const errorHandlingEpic: Epic = (action$) =>
  action$.pipe(
    filter(({ type }) => type.endsWith('/failed')),
    mergeMap((action: PayloadAction<ErrorResponse>) => {
      // eslint-disable-next-line no-console
      console.error(action);

      const extraActions = [];

      if (action?.payload?.errorCode === 'ROLE_NOT_FOUND') {
        extraActions.push(navigate({ to: '/' }));
      }

      return [
        openSnackbar({
          snackbarType: 'error',
          snackbarMessage: translateError(action?.payload),
        }),
        ...extraActions,
      ];
    }),
  );

export default errorHandlingEpic;
